import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=7a6425cc"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a6425cc')) {
      api.createRecord('7a6425cc', component.options)
    } else {
      api.reload('7a6425cc', component.options)
    }
    module.hot.accept("./Faq.vue?vue&type=template&id=7a6425cc", function () {
      api.rerender('7a6425cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Faq.vue"
export default component.exports